import {
  CREATE_USERGROUP,
  UPDATE_USERGROUP,
  LOAD_USERGROUP,
  REMOVE_LISTS,
  LOAD_USERGROUP_DETAIL
} from "./actions";

const initialState = {
  lists: [],
  total: 1,
  loading: false,
  detailLoading: false,
  draw: -1,
  msg: "",
  selectedUsergroup: {
    usergroup_id: null,
    name: "",
    company: [],
    is_base: false,
    active: true,
    permission: []
  }
};

export default (state = initialState, action) => {
  switch (action.type) {
    case REMOVE_LISTS:
      return initialState;
    case LOAD_USERGROUP.REQUEST:
      const { loading } = action.payload;
      return {
        ...state,
        loading: loading
      };
    case LOAD_USERGROUP.SUCCESS:
      return {
        ...state,
        lists: action.payload.lists.data,
        total:action.payload.lists.total_rows,
        loading: false,
      };
    case LOAD_USERGROUP_DETAIL.REQUEST:
      return {
        ...state,
        detailLoading: true
      };
    case LOAD_USERGROUP_DETAIL.SUCCESS:
      return {
        ...state,
        selectedUsergroup: action.payload.usergroup.data,
        detailLoading: false
      };
    case CREATE_USERGROUP.SUCCESS:
      const { res } = action.payload;
      return {
        ...state,
        selectedUsergroup: { ...state.selectedUsergroup, usergroup_id: res.id },
        usergroup_id: res.id,
        detailLoading: false
      };
    case UPDATE_USERGROUP.REQUEST:
      return {
        ...state,
        detailLoading: true
      };
    case UPDATE_USERGROUP.SUCCESS:
      if (action.payload.res.status === "fail")
        return {
          ...state,
          detailLoading: false
        };
      return {
        ...state,
        detailLoading: false,
        selectedUsergroup: initialState.selectedUsergroup
      };
      case CREATE_USERGROUP.FAILURE:
        return {
          ...state,
          detailLoading: false,
          msg: action.payload.err
        }
    default:
      return state;
  }
};
